module.exports = __webpack_public_path__ + "img/offers.4f851f10.svg";